import { render, staticRenderFns } from "./vanCustomField.vue?vue&type=template&id=4d3fdf28&scoped=true"
import script from "./vanCustomField.vue?vue&type=script&lang=js"
export * from "./vanCustomField.vue?vue&type=script&lang=js"
import style0 from "./vanCustomField.vue?vue&type=style&index=0&id=4d3fdf28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3fdf28",
  null
  
)

export default component.exports